import { Html, Plane } from "@react-three/drei";
import React from "react";
import { useSection, useTheme } from "../../../../common/hooks";
import WorkExperienceHtml from "../../../elements/WorkExperience";
import { SECTIONS } from "../../../../constants/sections";
import { TextureLoader } from "three/src/loaders/TextureLoader";
import { useLoader } from "@react-three/fiber";

const COVER_IMAGE_PATH = "/images/cover-we.png";
const COVER_IMAGE_DARK_PATH = "/images/cover-we-dark.jpg";
const COVER_IMAGE_LIGHT_PATH = "/images/cover-we-light.jpg";

export default function WorkExperience() {
  const { currentSection } = useSection();
  const { themeKey } = useTheme();
  const texture = useLoader(
    TextureLoader,
    themeKey === "light" ? COVER_IMAGE_LIGHT_PATH : COVER_IMAGE_DARK_PATH
  );

  return (
    <group position={[-3.04, 3.6, 0.1]} rotation-y={Math.PI / 2}>
      <Plane
        args={[2.6, 0.92]}
        position={[0, 0, 0.01]}
        visible={currentSection.name !== SECTIONS.EXPERIENCE}
      >
        <meshBasicMaterial transparent map={texture} />
      </Plane>
      <Html
        transform
        distanceFactor={1.5}
        style={{
          display:
            currentSection.name === SECTIONS.EXPERIENCE ? "block" : "none",
        }}
      >
        <WorkExperienceHtml
          currentSection={currentSection}
          themeKey={themeKey}
          coverPath={COVER_IMAGE_PATH}
        />
      </Html>
    </group>
  );
}
